
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    type: Number,
  },
  computed: {
    iconClass(): string {
      switch (this.type) {
        case 1:
          return 'icon-woman';
        case 2:
          return 'icon-man';
        case 3:
          return 'icon-uni';
      }
      return '';
    },
  },
});
